import { render, staticRenderFns } from "./DimensionError.vue?vue&type=template&id=21500095&"
import script from "./DimensionError.vue?vue&type=script&lang=js&"
export * from "./DimensionError.vue?vue&type=script&lang=js&"
import style0 from "./DimensionError.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports